import React from 'react'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import { SelectInput } from '@/modules/base/components/inputs'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  sourceInput: {
    zIndex: 50,
  },
  menuList: {
    maxHeight: 150,
  },
}))

const HubspotSelectInput = (props) => {
  const classes = useStyles()
  const { className, onChange, value, options, title } = props

  return (
    <SelectInput
      name='source'
      className={clsx(classes.sourceInput, className)}
      value={value.value}
      handleChange={onChange}
      allowCreate={false}
      label={title}
      customSelectOptions={{
        placeholder: lang.onboardingV2.user.sourcePlaceholder,
        maxMenuHeight: 180,
        className: classes.menuList,
        defaultOptions: true,
        loadOptions: options,
      }}
    />
  )
}

export default HubspotSelectInput
